<script setup lang="ts">
import { UiLockedBadge, UiText, UiButton, type UiIconProps, UiIcon, UiCard } from '@shopexperts/shared';
import { useMediaQuery } from '@vueuse/core';
import { computed } from 'vue';

const props = defineProps<{
    heading: string;
    locked?: boolean;
    action?: string;
    mobileAction?: string;
    actionDisabled?: boolean;
    description?: string;
    emptyStateText?: string;
    emptyStateIcon?: UiIconProps['name'];
}>();

const emit = defineEmits<{
    (actionName: 'action-click'): void
}>()

const actionLabel = computed(() => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    if (isMobile.value) {
        return props.mobileAction || props.action;
    }
    return props.action;
})

const onActionClick = () => {
    emit('action-click')
}
</script>

<template>
    <div class="flex flex-col gap-8 md:gap-4">
        <div class="flex items-center justify-between">
            <div class="flex flex-row items-center gap-1">
                <UiText as="h2" variant="h5" class="font-semibold" :text="props.heading" />
                <UiLockedBadge v-if="props.locked" />
            </div>
            <UiButton v-if="props.action" variant="primary" :label="actionLabel" @click="onActionClick" :disabled="props.actionDisabled">
                <template #before_label>
                    <UiIcon name="plus-square" class="w-5 h-5 text-se-primary group-hover/ui-button:text-se-dark se-transition-all" />
                </template>
            </UiButton>
        </div>
        <UiText as="p" variant="h6" class="text-se-gray-700 md:max-w-3/4 md:-mt-4" :text="props.description" v-if="props.description" />
        <slot name="notice" />
        <slot name="content">
            <UiCard padding="lg">
                <div class="flex flex-col items-center justify-center py-6 md:py-8">
                    <div class="max-w-125 flex flex-col items-center justify-center gap-6 text-se-gray-700">
                        <UiIcon :name="props.emptyStateIcon || 'image-placeholder'" class="w-14 h-14" />
                        <UiText as="p" variant="p" class="text-center text-[16px]"
                            :text="props.emptyStateText || 'Looks like you don’t have any content yet'" />
                    </div>
                </div>
            </UiCard>
        </slot>
    </div>
</template>